import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwWrapperComponent } from './pages/sw-wrapper/sw-wrapper.component';
import { SWQModalComponent } from './pages/sw-question-modal/swq-modal.component';
import { SectionWiseRoutingModule } from './section-wise.routing.module';
import { SingleColumnSwComponent } from './components/single-column-sw/single-column-sw.component';
import { SingleSectionSwComponent } from './components/single-section/single-section.component';
import { SwModifyTopComponent } from './components/sw-process-layout/sw-modify-top/sw-modify-top.component';
import { SwProcessContainerComponent } from './components/sw-process-layout/sw-process-container/sw-process-container.component';
import { EmailAddressComponent } from './components/sw-questions/EmailAddress/email-address.component';
import { InsuranceCompanyComponent } from './components/sw-questions/InsuranceCompany/insurance-company.component';
import { OtherPolicyHolderComponent } from './components/sw-questions/OtherPolicyHolder/other-policy-holder.component';
import { PhoneComponent } from './components/sw-questions/Phone/phone.component';
import { PolicyHolderInfoComponent } from './components/sw-questions/PolicyHolder/policy-holder-info.component';
import { PolicyStartRealDateComponent } from './components/sw-questions/PolicyStartRealDate/policy-start-real-date.component';
import { PostalCodeComponent } from './components/sw-questions/PostalCode/postal-code.component';
import { InsurancePolicyDetailSwComponent } from './components/sw-sections/insurance-policy-section/insurance-policy-detail-sw.component';
import { InsuredPeopleDetailSwComponent } from './components/sw-sections/insured-people-details/insured-people-detail-sw.component';
import { OtherDetailSwComponent } from './components/sw-sections/other-section/other-detail-sw.component';
import { SwProcessComponent } from './pages/sw-process/sw-process.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { SwDiscardModalComponent } from './components/sw-process-layout/sw-discard/sw-discard-modal/sw-discard-modal.component';
import { SwDiscardHostDirective } from './components/sw-process-layout/sw-discard/sw-discard-host/sw-discard-host.directive';
import { SavePartailDetailsComponent } from './components/save-partail-details/save-partail-details.component';

@NgModule({
  declarations: [
    SwWrapperComponent,
    SwProcessComponent,
    SWQModalComponent,
    SwProcessContainerComponent,
    SwModifyTopComponent,
    OtherDetailSwComponent,
    InsuredPeopleDetailSwComponent,
    InsurancePolicyDetailSwComponent,
    SingleColumnSwComponent,
    SingleSectionSwComponent,

    SwDiscardModalComponent,
    SwDiscardHostDirective,
    SavePartailDetailsComponent,

    // Questions Components
    EmailAddressComponent,
    InsuranceCompanyComponent,
    OtherPolicyHolderComponent,
    PhoneComponent,
    PolicyHolderInfoComponent,
    PolicyStartRealDateComponent,
    PostalCodeComponent
  ],
  imports: [CommonModule, FormsModule, SectionWiseRoutingModule, SharedModule],
  providers: [],
  bootstrap: [SwWrapperComponent]
})
export class SectionWiseModule {}
